import { ActiveChannelDTO, ChannelDTO } from 'app/shared/models/channel.model';
import { IncludeModeEnum } from '../../enum/include-mode-type.enum';
import { MediaDTO, OrderedMediaDTO } from '../../../../shared/models/media.models';
import { ProductTier } from '../settings/tier.model';
import { ProductPricesSummary, ProductTagDTO, OrderedMediaVm } from './product.models';

export class AssortmentBaseModel {
  id: number;
  title: string;
  type: IncludeModeEnum;
  storeId: number;
  description: string;
  publishOnPreFrom: string;
  publishOnPreTo: string;
  status: AssortmentStatusTypeEnum;
  visibleForReOrder: boolean;
  visibleForPreOrder: boolean;
  lastModificationTime: string;
  creationTime: string;
  creatorId: number;
  lastModifierId: number;
  showcaseId?: number;
  order?: number | null;
  storeChannelId?: number;
  channel: ChannelDTO;
  constructor(init?: AssortmentBaseModel) {
    Object.assign(this, init);
  }
}
export class AssortmentDTO extends AssortmentBaseModel {
  pricesSummary: ProductPricesSummary;
  media: MediaDTO[];
  constructor(init?: AssortmentDTO) {
    super();
    Object.assign(this, init);
  }
}

export class AssormentModel extends AssortmentBaseModel {
  media: OrderedMediaDTO[];
}

export class AssortmentMediaDTO {
  mediaId: number;
  order: number;
  visible: boolean;
  constructor(init?: AssortmentMediaDTO) {
    Object.assign(this, init);
  }
}

export class AssortmentItemVM extends AssormentModel {
  imagePath: string;

  checked?: boolean;
  constructor(init?: AssortmentItemVM) {
    super();
    Object.assign(this, init);
  }
}

export class AssortmentVM extends AssortmentBaseModel {
  tags: ProductTagDTO[];
  tiers: ProductTier[];
  media: OrderedMediaVm[];
  channelSelected: ChannelDTO;
  constructor(init?: AssortmentVM) {
    super();
    Object.assign(this, init);
    if (!this.tags) this.tags = [];
    if (!this.tiers) this.tiers = [];
    if (!this.media) this.media = [];
    if (this.type === undefined || this.type === null) this.type = IncludeModeEnum.static;
  }
}

export class AssortmentPutDto {
  title: string;
  type: IncludeModeEnum;
  description: string;
  channelId: number;
  visibleForReOrder: boolean;
  visibleForPreOrder: boolean;
  showcaseId: number;
  order?: number | null;
  constructor(init?: AssortmentPutDto) {
    Object.assign(this, init);
  }
}


export enum AssortmentStatusTypeEnum {
  Published = 0,
  Draft = 1,
  UnPublished = 2
}

export interface AssortmentBulkOrderDto {
  assortmentId: number;
  order: number;
}

export interface AssortmentBulkOrderRequestDto {
  storeId: number;
  channelId: number;
  orders: AssortmentBulkOrderDto[];
}
